import { Typography } from '@mui/material';
import { Avatar, styled } from '@/core/ui';
export const SidebarUserProfileButton = styled('button', {
    shouldForwardProp: (prop) => prop !== 'sidebarCollapsed' && prop !== 'menuExpanded',
})(({ theme, sidebarCollapsed, menuExpanded }) => {
    const hoverColor = `color-mix(in oklab, ${theme.vars.palette.text.primary} 5%, transparent)`;
    return {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: '.5rem',
        padding: '.5rem',
        // Required to make button not overflow container when email is too long and goes out of sidebar width.
        width: '100%',
        border: 0,
        backgroundColor: menuExpanded ? hoverColor : 'transparent',
        borderRadius: `var(--gp-radius-lg)`,
        ':hover': {
            cursor: 'pointer',
            backgroundColor: hoverColor,
        },
        ':active': {
            backgroundColor: hoverColor,
        },
        ...(sidebarCollapsed && {
            flex: 'unset',
            justifyContent: 'center',
            margin: 'auto',
        }),
    };
});
export const SidebarUserDataContainer = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    overflow: 'hidden',
});
export const SidebarUserAvatar = styled(Avatar)({
    fontSize: '1rem',
    height: '2rem',
    width: '2rem',
    borderRadius: '20%',
    outlineOffset: '-1px',
    outlineWidth: '1px',
    outlineStyle: 'solid',
});
export const SidebarUserName = styled(Typography)(({ theme }) => ({
    fontSize: theme.typography.caption.fontSize,
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.text.primary,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    lineHeight: '1.125rem',
    width: '100%',
    textAlign: 'left',
}));
export const SidebarUserEmail = styled(SidebarUserName)(({ theme }) => ({
    fontSize: theme.typography.helper.fontSize,
    fontWeight: theme.typography.fontWeightRegular,
    color: theme.palette.text.muted,
    lineHeight: '.875rem',
}));
